<template>
    <div>
        <b-alert
            variant="danger"
            class="text-center"
            :show="show">
            <slot></slot>
        </b-alert>
    </div>
</template>

<script>
export default {
  props: {
    show: Boolean
  }
};
</script>
